import styles from './SystemMessage.module.scss';

type Props = {
  message: ChatMessage;
};

export default function SystemMessage({ message }: Props) {
  return <div className={styles.wrapper}>{message.caregiverDisplayText}</div>;
}
